export default "__VITE_ASSET__LxAk12Ho__"